<style scoped>
.button-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 64px;
    padding: 0px 10px 8px 10px;
    box-shadow: 0px 0px 10px 11px white;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    align-content: space-evenly;
    background-color: #ffffffe0;
}

.root {
    height: 100%;
    position: relative;
}

.button-container a {
    flex: 1;
    height: 100%;
    line-height: 56px;
    margin-left: 2.5px;
    margin-right: 2.5px;
}


.input-field, .input-field label{
    padding-left: 35px
}

ul.order-items li {
    padding-top: 24px;
}

ul.order-items li:not(:last-child) {
    border-bottom: 1px solid #efefef;
}

.capitalized {
  text-transform: capitalize;
}
</style>

<style>
.modal-body .container {
  height: auto !important;
}
</style>

<template lang="pug">
    .root
      .vspace.large
      .row
        .col.s12
          p.title.large.no-margin-bottom {{order.referenceNumber}}
          p.subtitle.small.no-margin-top.green-text {{paymentMode}}
          .vspace.medium
          p.subtitle.micro Ordered on 
            span.black-text {{$utils.formatter.formatLongDateTime(order.createdAt)}}

      .row(v-if='order.confirmationStatus === STATUS_PENDING')
        .col.s12
          a.btn.grey.lighten-5.black-text(@click='showUpdateModal(STATUS_CANCELLED)') Cancel Order
          | &nbsp;
          a.btn.waves-effect.indigo(@click='showUpdateModal(STATUS_CONFIRMED)') Confirm Payment
      .row(v-else)
        .col.s12
          p.capitalized(:class="getConfirmationStatusClass(order.confirmationStatus)") {{`${getConfirmationText(order.confirmationStatus)}`}}
            v-icon(:class="getConfirmationStatusClass(order.confirmationStatus)", right) {{`${getConfirmationStatusIcon(order.confirmationStatus)}`}}
      .divider.col.s12
      .vspace.large.col.s12
      .row
        .col.s12
          p.subtitle.small Ordered by
          p.title.small {{receiver}}
      .row
        .col.s12
          p.subtitle.small Deliver to
          p.title.small {{deliveryAddress}}
      .row
        .col.s12
          p.subtitle.small Items
          ul.order-items
            li(v-for='item in sortedOrderItems')
              .row
                .col.s12.m8
                  span.title.medium.text-uppercase.black-text {{item.quantity}} X {{item.productVariant.product.name }} 
                    span.subtitle.micro(:class='getStatusClass(item.status)') &nbsp;&nbsp;{{item.status}}
                    span.subtitle.micro(:class='getStatusClass(item.status)', v-if='item.status === STATUS_INTRANSIT && item.deliveredBy === "inomph"') (Inom.ph)
                    p.subtitle.micro ({{item.productVariant.variantCode}})
                    p.subtitle.micro Deliver {{getDeliverySchedule(item.deliverySchedule)}}
                    p.subtitle.micro Fulfilled by {{item.shop.name}}
                .col.s12.m4
                  p.right-align {{$utils.formatter.formatAmount(item.price * item.quantity)}}
              .row(v-if='item.issue')
                .col.s12
                  p.red-text 
                    i.material-icons.left warning 
                    | {{item.issue}}
</template>
<script>
// import AlertModalContent from 'inomph-common/dist/components/alert-modal-content'
import ModalContent from './shared/modal.vue'

export default {
  props: ['order'],
  components: {
    ModalContent,
  },
  data () {
    return {
      modal: null,
      STATUS_NEW: 'new',
      STATUS_DECLINED: 'declined',
      STATUS_CANCELLED: 'cancelled',
      STATUS_PROCESSING: 'processing',
      STATUS_INTRANSIT: 'in-transit',
      STATUS_DELIVERED: 'delivered',
      STATUS_PENDING: 'pending',
      STATUS_CONFIRMED: 'confirmed',
      selectedItems: []
    }
  },
  watch: {
    '$route.params.referenceNumber' () {
      this.resetSelection()
    }
  },
  computed: {
    paymentMode () {
      return this.order.paymentOption === 'cash'
          ? 'Cash'
          : this.order.paymentOption === 'bank'
            ? 'Bank Deposit'
            : ''
    },
    receiver () {
      return `${this.order.account.firstName} ${this.order.account.lastName} (${this.order.account.email} | ${this.contactNumber})`
    },
    deliveryAddress () {
      return this.order.orderItems[0].address
    },
    contactNumber () {
      return this.order.orderItems[0].contactNumber
    },
    sortedOrderItems () {
      let copy = this.order.orderItems.slice()
      return copy.sort(this.sortCompareItem)
    }
  },
  methods: {
    showUpdateModal (status) {
      const modalParams = {
        // content: ModalContent,
        bind: {
          title: `${status === this.STATUS_CANCELLED ? 'Cancel' : 'Confirm'} ${this.order.referenceNumber}`,
          message: 'Are you sure?',
          positiveButton: {
            message: 'Yes',
            onClick: this.updateOrder.bind(this, status)
          },
          negativeButton: {
            message: 'No',
            onClick: () => {
              this.modal.close()
            }
          },
        },
        dialog: true,
      }

      // this.$store.dispatch('modal/open', modalParams).then(modal => {
      //   this.modal = modal
      // })
      this.$store.dispatch('_modal/open', modalParams).then(modal => {
        this.modal = modal
      })
    },
    sortCompareItem (itemA, itemB) {
      if (itemA.status === itemB.status) {
        return 0
      }

      if ([this.STATUS_DECLINED, this.STATUS_CANCELLED].includes(itemA.status) || itemB.status === this.STATUS_NEW) {
        return 1
      }

      if (itemA.status === this.STATUS_NEW
        || (itemA.status === this.STATUS_PROCESSING && (itemB.status === this.STATUS_INTRANSIT || itemB.status === this.STATUS_DELIVERED)) || (itemA.status === this.STATUS_INTRANSIT && itemB.status === this.STATUS_DELIVERED)
        || [this.STATUS_DECLINED, this.STATUS_CANCELLED].includes(itemB.status)) {
        return -1
      }

      return 1
    },
    canSelect (item) {
      return ![this.STATUS_DECLINED, this.STATUS_DELIVERED, this.STATUS_CANCELLED].includes(item.status)
    },
    resetSelection () {
      this.selectedItems = []
      document.querySelectorAll('input[type=checkbox]').forEach(checkbox => {
        checkbox.checked = false
      })
    },
    getDeliverySchedule (value) {
      if (value === 'same_day') {
        return 'By Today'
      } else if (value.startsWith('range')) {
        return 'By ' + value.split(':')[1].replace(';', ' to ') + ' business days'
      } else if (value.startsWith('scheduled')) {
        return 'On ' + value.split(':')[1]
      }
    },
    getStatusClass (status) {
      return {
        'indigo-text': status === this.STATUS_NEW,
        'green-text': status === this.STATUS_DELIVERED,
        'red-text': status === this.STATUS_DECLINED || status === this.STATUS_CANCELLED,
        'blue-text': status === this.STATUS_INTRANSIT,
        'orange-text': status === this.STATUS_PROCESSING
      }
    },
    getConfirmationStatusClass (status) {
      return {
        'green-text': status === this.STATUS_CONFIRMED,
        'red-text': status === this.STATUS_CANCELLED, 
      }
    },
    getConfirmationText (status) {
      if(status === this.STATUS_CANCELLED) return 'Order Cancelled'
      else return 'Payment Confirmed'
    },
    getConfirmationStatusIcon (status) {
      if(status === this.STATUS_CANCELLED) return 'remove_circle'
      else return 'check_circle'
    },
    updateOrder (status) {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        return this.$http.post(`${this.$config.API_URL}/admin/orders/${this.order.id}/confirmation-status`, {
          status: status
        }, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
      }).then(result => {
        this.$emit('orderUpdated', {id: result.data.id, confirmationStatus: result.data.confirmationStatus})
        this.$snackbar.success('Order ' + status)
        // this.modal.close()
        this.$store.dispatch('_modal/close');
      }).catch(err => {
        this.$log.error(err)
        this.$snackbar.error('Oops, something went wrong while updating the order')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-order-details.vue